import React, { useState } from "react";

const Heading = () => {
    return (
        <div className="heading">
            <h1>todos</h1>
        </div>
    );
};

export default Heading;